import React from "react";

const ImageViewModal = ({
  show,
  onHide,
  imageSrc,
  defaultImage = "/assets/images/default-package.jpg",
  title = "Image Preview",
  aspectRatio = "4/3", // Changed to match upload modal's aspect ratio
}) => {
  return (
    <div
      className={`modal fade ${show ? "show" : ""}`}
      style={{
        display: show ? "block" : "none",
        backgroundColor: "rgba(0,0,0,0.5)",
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onHide}
            ></button>
          </div>
          <div className="modal-body text-center">
            <div
              className="image-box mb-3" // Added mb-3 to match upload modal
              style={{
                width: "100%",
                aspectRatio: aspectRatio, // Now using the same aspect ratio
                border: "2px dashed #ccc", // Added border to match upload modal
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                backgroundColor: "#f8f9fa",
                margin: "0 auto",
              }}
            >
              <img
                src={imageSrc || defaultImage}
                alt={imageSrc ? "Preview" : "Default"}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover", // Using cover to fill the container
                }}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-danger" onClick={onHide}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageViewModal;
